module.exports = __webpack_public_path__ + "img/category-brand.daf74a1f.png";